module.exports = __webpack_public_path__ + "media/images/emblems/Luzein_wappen-39bd9e011a9da4dd27cc924b709af5dc.svg";